export const LOADING = "Loading...";
export const REQUIRED = "Required";